<template>
    <div class="news-page" @scroll="bingsrcoll">
        <!-- 正文 -->
        <div class="hidden-sm-and-down">
            <div class="first-page" v-if="informationData.children.length!=0">
                <img v-if="informationData.children[0].requestType.indexOf('image')>-1" :src="informationData.children[0].requestPath" :alt="informationData.dictLabel" style="width:100%;">
            </div>
            <div class="scenemain col-md-90">
                <div style="padding:0px 0px 67px 0px">
                <div style="margin-bottom:56px">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item to="/news" v-if="isEn ==='0'" style="font-size:16px">新闻动态</el-breadcrumb-item>
                        <el-breadcrumb-item to="/news" v-if="isEn ==='1'" style="font-size:16px">News and Trends</el-breadcrumb-item>
                        <el-breadcrumb-item to="/newsList" v-if="type == '2' && isEn ==='0'" style="font-size:16px">新闻列表</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{name:'newsList_en'}" v-if="type == '2' && isEn ==='1'" style="font-size:16px">News list</el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(item, index) in news_listRoute" :key="index">
                            <router-link v-if="isEn ==='0'" :to="{ path: item.path }" style="font-size:16px">
                                {{ item.meta.title }}
                            </router-link>
                          <router-link v-if="isEn ==='1'" :to="{ name: 'newsDetail_en' }" style="font-size:16px">
                            {{ 'Details' }}
                          </router-link>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                    <h1 style="text-align: center;font-weight: bolder;font-size: 32px;padding-bottom: 10px;">
                        {{ newsDetailData.title }}
                    </h1>
                    <p style="font-family: PingFangSC-Regular;font-size: 16px;color: #838383;letter-spacing: 0;text-align: center;line-height: 16px;">{{newsDetailData.publishTime}}</p>
                </div>
                <mdPreview :newsDetailData="newsDetailData.content" :imageClick="imageClick" style="height: 100%"></mdPreview>
            </div>
            <home-foot></home-foot>
        </div>
        <!-- 移动端 -->
        <div class="visible-sm-and-down">
            <div style="padding:25px 25px 37px 25px">
                    <h1 style="text-align: center;font-weight: bolder;font-size: 24px;padding-bottom: 6px;">
                        {{ newsDetailData.title }}
                    </h1>
                    <p style="font-family: PingFangSC-Regular;font-size: 14px;color: #838383;letter-spacing: 0;text-align: center;line-height: 14px;">{{newsDetailData.publishTime}}</p>
            </div>
            <mdPreview :newsDetailData="newsDetailData.content" style="height: 100%;padding: 0px 25px 30px 25px;" :imageClick="imageClick"></mdPreview>
            <home-foot></home-foot>
        </div>

    </div>
</template>



<script scope>
import HomeFoot from "@/components/HomeFoot";
import mdPreview from "@/components/mdPreview";
export default {
    name: "newsDetail",
    data() {
        return {
            scroll_Value: 0,
            news_listRoute: [],
            imageClick:false,
            // 新闻详情
            newsDetailData: {},
            informationData:{},
            type:'',
            isEn: '0',
        };
    },

    components: {
        HomeFoot, mdPreview
    },
    watch: {
        $route(to, from) {
            //监听路由变化
            this.getBreadcrumb();
        },
    },

    created() {
        window.scrollTo(0,0);
        this.getBreadcrumb();
        this._isMobile()
        this.$picData.map((item) => {
            if (item.dictCode == 150) {
                this.informationData = item
            }
        })
        this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0')
    },

    mounted() {
        $('.news-page').animate({ scrollTop: 0 }, 600);
        let newsId = this.$route.query.uuid;
        this.type = this.$route.query.type
        this.getNewsInfo(newsId);
         if (this._isMobile()) {
            this.imageClick = false
        } else {
            this.imageClick = null

        }
    },
    methods: {
         _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        bingsrcoll(e) {
            this.scroll_Value = e.srcElement.scrollTop;
        },
        getBreadcrumb() {
            this.news_listRoute = []
            this.news_listRoute = this.$route.matched.filter(
                (item) => item.meta && item.meta.title
            );
        },

        /**
         * 获取新闻详情
         */
        getNewsInfo(id){
            this.newsDetailData = {};
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/news/getNewsInfo/${id}`,
            ).then((response)=>{
                let res = response.data;
                if(res.code == 200){
                    this.newsDetailData = res.data;
                }
            }).catch(res => {})
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news-page {
    padding-top: 65px;
    height: 100%;
}

.scenemain {
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 56px;
}

@media only screen and (max-width:991px) {
    .news-page {
        padding-top: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/newsDetail.vue